import { api } from '@/lib/api'
import type { Region, RegionRequest, RegionUpdateRequest, RegionUser, UserRegion } from './types'

// ----- dictionary -----

export async function listRegions(activeOnly: boolean): Promise<Region[]> {
  const r = await api.get<Region[]>('/api/regions', { params: { activeOnly } })
  return r.data
}

export async function createRegion(payload: RegionRequest): Promise<Region> {
  const r = await api.post<Region>('/api/regions', payload)
  return r.data
}

export async function updateRegion(code: string, payload: RegionUpdateRequest): Promise<Region> {
  const r = await api.put<Region>(`/api/regions/${code}`, payload)
  return r.data
}

export async function deleteRegion(code: string): Promise<void> {
  await api.delete(`/api/regions/${code}`)
}

export async function reorderRegions(codes: string[]): Promise<void> {
  await api.put('/api/regions/order', { codes })
}

// ----- assignment -----

export async function listUserRegions(): Promise<UserRegion[]> {
  const r = await api.get<UserRegion[]>('/api/user-regions')
  return r.data
}

export async function assignUserRegion(userId: number, regionCode: string): Promise<void> {
  await api.put(`/api/users/${userId}/region`, { regionCode })
}

export async function unassignUserRegion(userId: number): Promise<void> {
  await api.delete(`/api/users/${userId}/region`)
}

export async function listRegionUsers(code: string): Promise<RegionUser[]> {
  const r = await api.get<RegionUser[]>(`/api/regions/${code}/users`)
  return r.data
}
